<template>
  <!-- app一级页权限控制 -->
  <div class="app-auth-page">
    <div class="page-content" v-if="hasAuth">
      <slot></slot>
    </div>
    <div class="no-auth" v-else>
      <img src="@/assets/imgs/img_no_permission.png" alt class="no-auth-img" />
      <p class="text">功能即将上线，敬请期待！</p>
    </div>
  </div>
</template>

<script>
import permission from '@/common/permission';

export default {
  name: 'app-auth-page',
  data() {
    return {
      hasAuth: false,
      blackList: [
        {
          id: '2', // 后端
          arr: [
            '/manage-stock',
            '/manage-stock-history'
          ],
        },
        {
          id: '3', // 黄牛
          arr: [
            '/manage-order',
            '/manage-data',
            '/manage-stock',
            '/manage-stock-history'
          ],
        },
      ],
    };
  },
  watch: {
    roleValue() {
      this.checkAuth();
    },
  },
  props: {
    roleValue: {
      type: String,
      default() {
        return '';
      },
    },
  },
  components: {},
  computed: {
    permissionData() {
      return permission.value;
    },
    routePath() {
      return this.$route.path;
    },
  },
  created() {},
  mounted() {
    this.checkAuth();
  },
  methods: {
    checkAuth() {
      this.hasAuth = this.permissionData.roleArr.some(item => {
        // 校验无权限路由
        const specialRole = this.blackList.find(i => i.id === item.value);
        if (specialRole) {
          const specialRoute = specialRole.arr.find(i => i === this.routePath);
          if (specialRoute) return false;
        }
        return item.value === this.roleValue;
      });
    },
    // 确认角色权限后执行回调
    loadPage(cb) {
      if (this.hasAuth) {
        cb && cb();
      } else {
        console.log('无权限');
        const index = this.permissionData.roleArr.findIndex(
          item => item.value === this.roleValue
        );
        if (index === -1) {
          console.log('当前权限无此角色，重置默认角色');
          this.$emit('onResetRole');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-auth-page {
  width: 100%;
}
.no-auth-img {
  display: block;
  width: 80px;
  height: 80px;
  margin: 214px auto 0;
}
.text {
  margin-top: 12px;
  font-size: 14px;
  color: #cccccc;
  line-height: 20px;
  text-align: center;
}
</style>

